export const FEATURE_HIGHLIGHT_PATH = '/v1/onboarding-highlight-sets/';
